// config/index.js
const getConfigDetails = {
    instance_baseURL: process.env.REACT_APP_INSTANCE_BASE_URL,
    config_baseURL: process.env.REACT_APP_CONFIG_BASE_URL,
    clientSecret: process.env.REACT_APP_CLIENT_SECRET,
    adminBaseUrl: process.env.REACT_APP_ADMIN_BASE_URL,
    cmsBaseUrl: process.env.REACT_APP_CMS_BASE_URL,
    env: process.env.REACT_APP_ENV || 'development',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export default getConfigDetails;
